/* tslint:disable */

/**
 */
export class ModuleApp {
    id?: number;
    name?: string;
    display_name?: string;
    description?: string;
    created_at?: string;
    updated_at?: string;
}
